module.exports = __webpack_public_path__ + "img/lock.42a7560c.svg";